export const COUNTRIES = {
  eg: {
    code: 'eg',
    name: 'Egypt',
    name_ar: 'مصر',
    flag: '/assets/flags/eg.svg'
  },
  sa: {
    code: 'sa',
    name: 'Saudi Arabia',
    name_ar: 'المملكة العربية السعودية',
    flag: '/assets/flags/sa.svg'
  },
  ae: {
    code: 'ae',
    name: 'United Arab Emirates',
    name_ar: 'الإمارات العربية المتحدة',
    flag: '/assets/flags/ae.svg'
  },
  kw: {
    code: 'kw',
    name: 'Kuwait',
    name_ar: 'الكويت',
    flag: '/assets/flags/kw.svg'
  },
  bh: {
    code: 'bh',
    name: 'Bahrain',
    name_ar: 'البحرين',
    flag: '/assets/flags/bh.svg'
  },
  qa: {
    code: 'qa',
    name: 'Qatar',
    name_ar: 'قطر',
    flag: '/assets/flags/qa.svg'
  },
  om: {
    code: 'om',
    name: 'Oman',
    name_ar: 'عمان',
    flag: '/assets/flags/om.svg'
  }
};

export const getCountryInfo = (code, language = 'en') => {
  const country = COUNTRIES[code.toLowerCase()];
  if (!country) return null;
  
  return {
    ...country,
    displayName: language === 'ar' ? country.name_ar : country.name
  };
};
